import { IconButton } from '@components/core/icon-button.component';
import { XIcon } from 'lucide-react';
import React, { PropsWithChildren, ReactNode } from 'react';
import { cn } from '../../lib/utils';

export type ModalHeaderProps = {
  actions?: React.ReactNode;
  className?: string;
  onClose?: () => void;
  subtitle?: ReactNode;
  title?: ReactNode;
};

export const ModalHeader: React.FC<PropsWithChildren<ModalHeaderProps>> = (props) => {
  const { actions, children, onClose, title, subtitle, className } = props;

  if (!title && !children) return null;

  return (
    <div className={cn('border-b border-solid border-gray-300 p-4 w-full', className)}>
      <div className={cn('flex w-full items-start', title ? 'justify-between' : 'justify-end')}>
        <div className="flex flex-col">
          {title && <div className="text-lg">{title}</div>}
          {subtitle}
        </div>
        <div className="flex items-center gap-2">
          {children}
          {actions}
          {onClose && (
            <IconButton
              ariaLabel="Close modal"
              icon={<XIcon />}
              onClick={onClose}
              variant="secondary"
            />
          )}
        </div>
      </div>
    </div>
  );
};
